
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { AuthMixin, BAIconsMixin, StringsMixin, VuetifyMixin, StatusMixin, StripeMixin, PurchaseMixin, AthleteRoutingMixin, AthleteProfileMixin, StylesMixin } from '@/mixins';
import { BAPartnerProduct, BAPurchaseModel, BAPartnerModel } from '@/models';
import { userStore } from '@/store';
import OnboardingDialog from '@/views/onboarding/OnboardingDialog.vue';

@Component({
    components: {
        OnboardingDialog,
    }
})
export default class PartnerProductPurchaseDialog extends Mixins(BAIconsMixin, StringsMixin, VuetifyMixin, StatusMixin, StylesMixin, AuthMixin, StripeMixin, PurchaseMixin, AthleteProfileMixin, AthleteRoutingMixin) {
    @Prop({required: true}) product: BAPartnerProduct;
    @Prop() partner: BAPartnerModel;

    gotoPartnerWebsite() {
        if( this.IsEmpty(this.partner?.website) ) return;

        window.open(this.partner.website, "_blank");
    }

    onOrderRequest() {
        this.athleteProfile = userStore.AthleteProfile;
        if( this.IsNotEmpty(this.athleteProfile) ) {
            this.purchaseRequest = new BAPurchaseModel().load({
                parentId: this.AthleteId,
                productId: this.product.id,
                priceId: this.product.Price?.id,
                date: new Date(),
                requested: true,
                completed: false,
                data: this.PurchaseAthleteData(this.product.dataLabels, this.athleteProfile),
            })
        }
        this.onShowPurchaseDialog();
    }

    async onProceedToPayment() {
        try {
        const purchase = await this.savePurchaseRequest();

        if( this.product.IsFree ) {
                await this.completePurchaseRequest(purchase, this.athleteProfile);
                this.reloadWindow();
            } else {
                // go to Stripe to purchase the product
                this.buyPartnerProduct(this.product, this.product.Price, this.AthleteId);
            }
        } catch(e) {
            this.setError(`Unable to process purchase. Contact Best Athletes for support:\n\n${e.message}`);
            this.waitForStripe = false;
        }
    }

    onboardingComplete() {
        this.showOnboardingDialog = false;
        this.onOrderRequest();
    }
    onInfo(info: string) {
        console.log(`INFO: ${info}`);
    }
    onError(error: string) {
        console.error(`ERROR: ${error}`);
    }
    onInput(event: any) {
        console.log(`EVENT: `, event);
    }
    showOnboardingDialog: boolean = false;
}

